import { useState } from "react";

/**
 * True for the render in which `value` differs from the previous render's.
 * Lets a component react to a prop/derived-value transition with a state
 * update during render instead of a post-commit effect:
 *
 *   if (useValueChanged(matches) && matches) setIsOpen(true);
 */
export function useValueChanged<T>(value: T): boolean {
  const [prev, setPrev] = useState(value);
  if (Object.is(prev, value)) return false;
  setPrev(value);
  return true;
}
